import { Card, CardContent, Typography, Grid, Box, Skeleton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { PaddleStatus } from '../../../../types/admin';
import { formatDistanceToNow } from 'date-fns';

interface PaddleStatusCardProps {
  status: PaddleStatus;
  loading?: boolean;
}

export default function PaddleStatusCard({ status, loading }: PaddleStatusCardProps) {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Paddle Integration Status
          </Typography>
          <Skeleton variant="rectangular" height={100} />
        </CardContent>
      </Card>
    );
  }

  const StatusItem = ({ label, value, isConnected }: { label: string; value: string; isConnected?: boolean }) => (
    <Grid item xs={12} sm={6} md={3}>
      <Box>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {label}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isConnected !== undefined &&
            (isConnected ? (
              <CheckCircleIcon sx={{ fontSize: 20, color: 'success.main' }} />
            ) : (
              <ErrorIcon sx={{ fontSize: 20, color: 'error.main' }} />
            ))}
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {value}
          </Typography>
        </Box>
      </Box>
    </Grid>
  );

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Paddle Integration Status
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Payment processor connection and webhook health
        </Typography>

        <Grid container spacing={3}>
          <StatusItem label="API Connection" value={status.api_connected ? 'Connected' : 'Disconnected'} isConnected={status.api_connected} />
          <StatusItem
            label="Last API Check"
            value={formatDistanceToNow(new Date(status.api_last_checked), { addSuffix: true })}
          />
          <StatusItem
            label="Last Sync"
            value={formatDistanceToNow(new Date(status.last_sync_at), { addSuffix: true })}
          />
          <StatusItem label="Webhook Success Rate" value={`${status.webhook_success_rate}%`} />
        </Grid>
      </CardContent>
    </Card>
  );
}
